import React from 'react';
import { Fab, Zoom, useTheme } from '@mui/material';
import { Chat as ChatIcon } from '@mui/icons-material';

const FloatingChatButton = ({ bot, chatOpen, toggleChat }) => {
  const theme = useTheme();
  
  return (
    <Zoom in={!chatOpen}>
      <Fab
        color="primary"
        aria-label="chat"
        sx={{
          position: 'fixed',
          bottom: 30,
          right: 30,
          backgroundColor: bot?.customizations?.primaryColor || theme.palette.primary.main,
          boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
          '&:hover': {
            backgroundColor: bot?.customizations?.primaryColor 
              ? `${bot.customizations.primaryColor}DD` 
              : theme.palette.primary.dark
          },
          animation: 'pulse 2s infinite'
        }}
        onClick={toggleChat}
      >
        <ChatIcon />
      </Fab>
    </Zoom>
  );
};

export default FloatingChatButton;
